import React, { ReactNode } from "react";
import "./Answer.module.css";

type HtmlParsedAnswer = {
    answerHtml: string | JSX.Element[];
    citations: string[];
    citationWithLink?: any;
};

export function parseAnswerToHtml(answer: string, onCitationClicked: (citationFilePath: string) => void, citationWithLink?: any): HtmlParsedAnswer {
    const citations: string[] = [];
    function isCitationPresent(citationToCheck: string): boolean {
        const caseSensitiveMatch = citationWithLink.find((item:any) => item.citation.split("/").pop().trim() === citationToCheck.trim());
        return caseSensitiveMatch !== undefined;
      }
    let parsedAnswer = answer.trim();
    const citationMap = new Map<string, string>();
    if (citationWithLink) {
        citationWithLink.forEach((item: { citation: string; link: string }) => {
            citationMap.set(item.citation.split("/").pop() || "", item.link);
        });
    }
    let formattedText: string = parsedAnswer
        .split("\n")
        .map((line: any, index: any) => line + "\n")
        .join("");
    let lastIndex = formattedText.length;
    for (let i = formattedText.length - 1; i >= 0; i--) {
        if (formattedText[i] === "]") {
            break;
        } else if (formattedText[i] === "[") {
            lastIndex = i;
            break;
        }
    }

    const truncatedAnswer = formattedText.substring(0, lastIndex);
    formattedText = truncatedAnswer;
    const paragraphs = formattedText.split(/\n/g);

        const fragments:string[] = paragraphs.map((paragraph) => {

        const parts = paragraph.split(/\[([^\]]+)\]/g);
        
        let citationIndex: number;
        const paragraphFragments = parts.map((part, partIndex) => {
            if (partIndex % 2 === 0) {
              if (part.trim() === "") {
                return;
              }
              return part
            } else {
              if (citations.indexOf(part) !== -1) {
                citationIndex = citations.indexOf(part) + 1;
              } else {
                if(isCitationPresent(part)){
                    citations.push(part);
                    citationIndex = citations.length;
                }
                else if (part.includes("https://"))
                {
                  return `[<i>${" "+part+" "}</i>](${part})`
                }
                else 
                  return
              }
              const link = citationMap.get(part) || "";
                return link !== ""
                ? `<sup>${citationIndex}</sup>`
                :`<sup>${citationIndex}</sup>`
            }
          });
          return paragraphFragments.join('')
    });
    return {
        answerHtml: fragments.join('\n')+"",
        citations
    };
}
